export default "__VITE_ASSET__CxzaGzdk__"